<template>
	<div>
		<!--<div class="vh-100 bg-grey p-d-72">-->
		<div class="vh-100 bg-grey">
			<SOTitleBar
				:page-title="'Detail Paket Deposit'"
				:type="'back'"
				@back="back"
			/>

			<div class="content-wrapper main-page list-transaksi-deposit-content">
				<div class="p-x-20 p-y-16 bg-white" v-if="listTransaksiDepositData.data !== undefined">
					<div class="f-bold f-18 f-c-black m-d-8">
						{{ listTransaksiDepositData.data.nama_deposit }}
					</div>
					<div class="d-flex-between-center">
						<div class="f-regular f-14">
							<span class="f-c-midgrey">Layanan </span>
							<span class="f-c-black">{{ listTransaksiDepositData.data.nama_layanan }}</span>
						</div>
						<div class="f-regular f-14">
							<span class="f-c-midgrey">Saldo </span>
							<span class="f-c-black">
								{{ formatRupiah(listTransaksiDepositData.data.saldo) }}
								{{ listTransaksiDepositData.data.nama_satuan }}
							</span>
						</div>
					</div>
					<div class="f-regular f-12 f-c-midgrey"
					     v-if="listTransaksiDepositData.data.masa_aktif_raw === null">
						Aktif Selamanya
					</div>
					<div class="f-regular f-12 f-c-midgrey"
					     v-else-if="$moment(listTransaksiDepositData.data.masa_aktif_raw).diff($moment(), 'days') >= 0">
						Aktif {{
							($moment(listTransaksiDepositData.data.masa_aktif_raw).format('YYYY') > 2045) ? 'Selamanya' : 'hingga ' + listTransaksiDepositData.data.masa_aktif_formated
						}}
					</div>
					<div class="f-regular f-12 f-c-red" v-else>
						Telah kedaluwarsa ({{ listTransaksiDepositData.data.masa_aktif_formated }})
					</div>
				</div>

				<div class="d-flex p-x-20 p-y-12">
					<div class="f-regular f-16 f-c-midgrey">
						Riwayat Aktivitas
						<span class="m-l-4 m-r-4">•</span>
					</div>
					<div>
						<SODropdown
							:id="'dropdown-transaksi-deposit'"
							:title="dropdownItems[dropdownItems.findIndex(a => a.selected === true)].title"
							:items="dropdownItems"
							@update-data="(val) => { dropdownItems = val }"
							@action="doFilter"
						/>
					</div>
				</div>

				<div class="p-x-20" :class="{'bg-white': !pageSetting.loading.list}">
					<SOCardPaketDepositSkeleton v-if="pageSetting.loading.list"/>

					<SOEmptyState
						v-if="listTransaksiDepositData.data.list_transaksi_deposit.length === 0 && !pageSetting.loading.list"
						:message="'Data tidak ditemukan'"
					/>

					<SOCardPaketDepositTransaksi
						v-if="!pageSetting.loading.list"
						v-for="transaksi in listTransaksiDepositData.data.list_transaksi_deposit"
						:key="transaksi.idtransaksi"
						:transaksi="transaksi"
						@detail="(transaksiDeposit) => { transaksiDeposit ?
						detailTransaksi(transaksi.idtransaksi) :
						detailTopUp(transaksi.idtransaksi)
						}"
					/>

					<SOLoadMoreLoading :id="'loading-list-transaki-deposit'" :loading="pageSetting.loading.loadMore"/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {mapGetters} from "vuex"
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOEmptyState from "@/so-components/global/ui/SOEmptyState";
import SODropdown from "@/so-components/global/ui/SODropdown";
import SOCardPaketDepositSkeleton from "@/so-components/modules/paket-deposit/SOCardPaketDepositSkeleton";
import SOCardPaketDepositTransaksi from "@/so-components/modules/paket-deposit/SOCardPaketDepositTransaksi";
import SOLoadMoreLoading from "@/so-components/global/ui/SOLoadMoreLoading";

const defaultDropdownItems = () => (
	[
		{
			title: "Semua",
			selected: true,
		},
		{
			title: "Transaksi",
			selected: false,
		},
		{
			title: "Top Up",
			selected: false,
		},
	]
)

export default {
	name: "PaketDepositTransaksi",
	components: {
		SOTitleBar,
		SOEmptyState,
		SODropdown,
		SOCardPaketDepositSkeleton,
		SOCardPaketDepositTransaksi,
		SOLoadMoreLoading,
	},
	computed: {
		...mapGetters("depositModule", {
			listTransaksiDepositData: "getListTransaksiDeposit",
			pagination: "getPagination",
		}),
	},
	data() {
		return {
			idcustomer: "",
			iddeposit: "",

			dropdownItems: defaultDropdownItems(),

			pageSetting: {
				loading: {
					list: true,
					loadMore: false,
				},
				error: {
					list: false,
				}
			}
		}
	},
	async mounted() {
		await this.flushData()
		this.setDefaultFilter()

		this.idcustomer = this.$route.params.idcustomer
		this.iddeposit = this.$route.params.iddeposit

		await this.getTransaksiDeposit()
		await this.scroll()
	},
	methods: {
		back() {
			// this.$router.push("/konsumen/detail/paket_deposit/" + this.idcustomer)
			this.$router.back()
		},
		async getTransaksiDeposit() {
			const res = await this.$store.dispatch("depositModule/fetchTransaksitDeposit", {
				idcustomer: this.idcustomer,
				iddeposit: this.iddeposit,
				tipe: this.dropdownItems.findIndex(a => a.selected === true)
			})
			if (!this.pageSetting.loading.list) {
				this.pageSetting.loading.loadMore = true
			} else {
				this.pageSetting.loading.list = false;
			}
			this.pageSetting.loading.loadMore = false
			this.$store.commit("helper/setScrollCalled", false)
			if (res.success) {
				this.pageSetting.error.list = false
				await this.$store.commit("depositModule/setNextPagination", {
					data: this.listTransaksiDepositData.data.list_transaksi_deposit
				})
			} else {
				this.pageSetting.error.list = true
				setTimeout(() => {
					this.pageSetting.error.list = false
				}, 10000)
				this.$toast.error(res.err)
			}
		},
		setDefaultFilter() {
			let query = this.$route.query
			if (Object.keys(query).length > 0) {
				this.dropdownItems.forEach((val, key) => {
					if (key !== Number(query.tipe)) {
						this.dropdownItems[key].selected = false
					} else {
						this.dropdownItems[key].selected = true
					}
				})
			} else {
				this.dropdownItems = defaultDropdownItems()
			}
		},
		scroll() {
			window.onscroll = async () => {
				if (this.pageSetting.error.list) {
					return
				}
				let payload = {
					idLoadMore: "loading-list-transaki-deposit",
					container: "list-transaksi-deposit-content",
					pagination: this.pagination,
					callback: this.getTransaksiDeposit,
				}
				await this.$store.dispatch("helper/scroll", payload)
			}
		},
		detailTransaksi(idtransaksi) {
			this.$router.push("/transaksi/reguler/detail/" + idtransaksi)
		},
		detailTopUp(id) {
			this.$router.push("/transaksi/deposit/topup/" + id)
		},

		async doFilter() {
			this.pageSetting.loading.list = true
			// await this.$store.commit("depositModule/resetListTransaksiDeposit")
			this.listTransaksiDepositData.data.list_transaksi_deposit = []
			await this.$store.commit("depositModule/resetPagination")
			await this.getTransaksiDeposit()
		},

		async flushData() {
			console.log("wowoow")
			await this.$store.commit("depositModule/resetListTransaksiDeposit")
			await this.$store.commit("depositModule/resetPagination")
			this.dropdownItems = defaultDropdownItems()
		}
	},
	beforeDestroy() {
		this.flushData()
	},
}
</script>